export default __webpack_public_path__ + "static/media/IMG_1636.2d69dd6f.jpg";